import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import { Marketing } from './Marketing'

const MarketingWrapper: FC = () => {
  const breadcrumbs = [
    {
      title: 'Dashboard',
      path: '/',
      isActive: true,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
  ]

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs} description={'Coupon'}>Marketing Management</PageTitle>
      <Marketing />
    </>
  )
}

export default MarketingWrapper
